import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center mb-5" }

import {computed, PropType, ref, watch} from "vue";
import {
  IBienBanGiaiTheResponseBase,
  IPhieuNhapKhoResponseBase,
  IPhieuXuatKhoResponseBase
} from "@/core/interfaces/ApiResponses";
import {useStore} from "vuex";
import {swalErrNotification} from '@/core/helpers/utils';
import {useDateTime} from "@/core/hooks/use-date-time-hook";
import {BienBanGiaiTheService} from '@/core/services/BienBanGiaiThe.service';
import {PhieuNhapKhoService} from '@/core/services/PhieuNhapKho.service';
import PhieuXuatKhoService from "@/core/services/Receipt.service";
import ConfirmationDialog from '@/components/confirmation-dialog/ConfirmationDialog.vue';
import DivCol from '@/layout/_shared/DivCol.vue';
import DivRow from '@/layout/_shared/DivRow.vue';
import LabelCustom from '@/components/shared/label-custom/LabelCustom.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmHoanThanh',
  props: {
  bienBanData: {
    type: Object as PropType<IBienBanGiaiTheResponseBase | null>,
    default: null,
  },
  for: {
    type: String as PropType<'phieu_nhap' | 'phieu_xuat' | 'bien_ban_giai_the'>,
    default: 'bien_ban_giai_the',
  },
  phieuNhapData: {
    type: Object as PropType<IPhieuNhapKhoResponseBase | null>,
    default: null,
  },
  phieuXuatData: {
    type: Object as PropType<IPhieuXuatKhoResponseBase | null>,
    default: null,
  },
  show: {
    type: Boolean as PropType<boolean>,
    required: true,
  },
},
  emits: ['close', 'confirm'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const completeDate = ref(new Date());

const store = useStore();

const currentYear = computed(() => store.getters.getSelectedYear);

watch(() => props.show, () => {
  if (props.show) {
    if (['phieu_nhap', 'phieu_xuat'].includes(props.for)) {
      completeDate.value = new Date(currentYear.value);

      return;
    }

    completeDate.value = new Date();
  }
});

const sendRequest = async () => {
  if (props.for === 'bien_ban_giai_the') {
    await BienBanGiaiTheService.completeBienBan({
      id_bien_ban: props.bienBanData?.id ?? 0,
      ngay_ra_xuong: completeDate.value,
    });

    return;
  }

  if (props.for === 'phieu_nhap') {
    await PhieuNhapKhoService.completePhieuNhapKho({
      id: props.phieuNhapData?.id ?? 0,
      ngay_hoan_thanh: completeDate.value,
    });

    return;
  }

  await PhieuXuatKhoService.updateNgayHoanThanh({
    id: props.phieuXuatData?.id ?? 0,
    ngay_hoan_thanh: completeDate.value
  });
};

const confirmHoanThanhBienBanHandler = async () => {
  try {
    await sendRequest();
  } catch (err) {
    emit('close');

    await swalErrNotification(err, 'Có lỗi xảy ra khi hoàn thành biên bản');
  }

  emit('confirm', {
    date: completeDate.value,
  });
};

const header = computed(() => {
  if (props.for === 'bien_ban_giai_the') return `Xác nhận hoàn thành biên bản số ${props.bienBanData?.so_bien_ban}?`;

  if (props.for === 'phieu_nhap') return `Xác nhận hoàn thành phiếu nhập số ${props.phieuNhapData?.so_phieu}?`;

  return `Xác nhận hoàn thành phiếu xuất số ${props.phieuXuatData?.so_phieu}?`;
});

const { disableDate } = useDateTime();

const disableDateValue = (time: Date) => {
  if (['phieu_nhap', 'phieu_xuat'].includes(props.for)) {
    return disableDate(time, currentYear.value);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!

  return (_openBlock(), _createBlock(ConfirmationDialog, {
    title: "Hoàn Thành?",
    width: "40%",
    "is-display": __props.show,
    onOnConfirmButtonClick: confirmHoanThanhBienBanHandler,
    onOnCloseButtonClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close'))),
    onOnCloseIconClick: _cache[2] || (_cache[2] = ($event: any) => (emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("h5", _hoisted_1, _toDisplayString(header.value), 1),
      _createVNode(DivRow, null, {
        default: _withCtx(() => [
          _createVNode(DivCol, {
            cols: 5,
            "additional-class": "d-flex align-items-center"
          }, {
            default: _withCtx(() => [
              _createVNode(LabelCustom, {
                "is-text-muted": true,
                "is-required": true
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Ngày hoàn thành")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(DivCol, { cols: 7 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: completeDate.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((completeDate).value = $event)),
                class: "w-100",
                "disabled-date": disableDateValue,
                format: "DD/MM/YYYY",
                type: "date"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["is-display"]))
}
}

})